'use client'
import React from 'react'
import styles from './styles.module.scss'
import { useSize } from './useSize'

const LoadingSpinner: React.FC<{ size?: 'sm' | 'md' }> = ({ size = 'md' }) => {
  const sizes = useSize(size)

  return (
    <svg
      className={styles.spinner}
      viewBox={sizes.viewBox}
      width={sizes.width}
      height={sizes.width}
    >
      <circle
        cx="0"
        cy="0"
        r={sizes.r}
        fill="none"
        className={styles.path}
        strokeWidth={sizes.strokeWidth}
      />
    </svg>
  )
}

export default LoadingSpinner
